import React, { useContext } from 'react';
import { Button, ButtonType } from '@riotgames/accounts-react-components';
import AppContext from '../../AppContext';

import cx from 'classnames';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';

const Promotion = ({ handleMoveNext }) => {
  const context = useContext(AppContext);

  const moveNext = () => {
    handleMoveNext();
  };

  const subTitlePanel = (
    <p className="help-text">
      업그레이드 후에는 Google/Apple 계정 혹은 아이디와 비밀번호를 이용하여
      <br />
      로그인하실 수 있습니다.
    </p>
  );

  return (
    <GridPanel
      title={<span style={{ lineHeight: 1.4 }}>현재 사용중인 계정을 라이엇 계정으로 업그레이드 합니다.</span>}
      subTitle={subTitlePanel}
      button={<Button buttonType={ButtonType.submit} onClick={moveNext} />}
    />
  );
};

export default Promotion;
